import React, { useState } from "react";
import api from "../api/client";
import './AdminLogin.css';

const AdminLogin = ({ onLoginSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await api.post(`/auth/login`, {
        email,
        password
      });

      const token = res.data.token;
      if (!token) throw new Error("No token received");

      localStorage.setItem("token", token);
      localStorage.setItem("admin", JSON.stringify(res.data.admin || {}));

      if (onLoginSuccess) onLoginSuccess();
    } catch (err) {
      console.error(err);
      setError(
        err.response?.data?.message ||
        "Invalid credentials or server error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <div className="login-logo">KTZ</div>
          <h1 className="login-title">Admin Login</h1>
          <p className="login-subtitle">Sign in to manage your business</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="admin@example.com"
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              className="form-input"
            />
          </div>

          {error && (
            <div className="alert alert-error">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="btn btn-primary btn-lg"
            style={{ width: '100%' }}
          >
            {loading ? "Signing in..." : "Login"}
          </button>
        </form>

        <div className="login-footer">
          Authorized personnel only
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
